module.exports = __webpack_public_path__ + "img/home-proshow4.64c9fc4b.png";